export default __webpack_public_path__ + "static/media/Daraz.035a2302.png";